<template lang="html">
<div class="single-chart">
    <canvas class="chart" :id="id" height="350" width="600"></canvas>
</div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data() {
        return {
            chart: null,
            id: 'single-chart-modal-canvas',
        };
    },
    props: {
        chartData: {
            type: Object,
            required: true,
        },
    },
    computed: {

    },
    methods: {
        /**
         * create the chart.js chart object
         */
        renderChart() {
            if (this.chart !== null) {
                return;
            }
            this.chart = {};

            this.chart = new Chart(this.id, this.chartData);
        },
    },
    // render the chart once the canvas element exists
    // (don't mount this component until the data prop is ready)
    mounted() {
        this.renderChart();
    },
};
</script>

<style scoped lang="scss">
.single-chart {

}
</style>



// WEBPACK FOOTER //
// src/components/SingleChart.vue